function _fireEventOnMarkerOrVisibleParentCluster(marker, markers, eventName) {
    if (eventName === 'click') {
        var visibleLayer = markers.getVisibleParent(marker);

        if (visibleLayer instanceof L.MarkerCluster) {
            // We want to show a marker that is currently hidden in a cluster.
            // Make sure it will get highlighted once revealed.
            markers.once('spiderfied', function () {
                marker.fire(eventName);
            });
            visibleLayer.spiderfy();
        } else {
            _unspiderfyPreviousClusterIfNotParentOf(marker, markers);
            marker.fire(eventName);
        }
    } else {
        marker.fire(eventName);
    }
}

function _unspiderfyPreviousClusterIfNotParentOf(marker, markers) {
    // Check if there is a currently spiderfied cluster.
    // If so and it does not contain the marker, unspiderfy it.
    var spiderfiedCluster = markers._spiderfied;

    if (
            spiderfiedCluster
            && !_clusterContainsMarker(spiderfiedCluster, marker)
            ) {
        spiderfiedCluster.unspiderfy();
    }
}

function _clusterContainsMarker(cluster, marker) {
    var currentLayer = marker;

    while (currentLayer && currentLayer !== cluster) {
        currentLayer = currentLayer.__parent;
    }

    // Say if we found a cluster or nothing.
    return !!currentLayer;
}

export default  _fireEventOnMarkerOrVisibleParentCluster;